import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Container, ContainerAssistentes, AssistenteStyle } from './GerandoResumo.styles';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { Backdrop, CircularProgress, Typography, Box, Button, LinearProgress, Fade, Grow, useTheme } from '@mui/material';
import { toast } from 'react-toastify';
import { geraResumoAssistenteEspecialistaStream, salvaResumoAsync } from '../../../services/resumo';
import Lottie from 'lottie-react';
import { CheckCircle, HourglassEmpty } from '@mui/icons-material';

function GerandoResumo() {
    const theme = useTheme();
    const params = useParams();
    const navigate = useNavigate();
    const [loadingResumo, setLoadingResumo] = useState(false);
    const [processandoAssistentes, setProcessandoAssistentes] = useState(false);
    const [assistenteAtualIndex, setAssistenteAtualIndex] = useState(0);
    const [showAssistente, setShowAssistente] = useState(true);
    const { atendimento, tiposResumos, setAtendimento } = useOutletContext();
    const tipoResumo = useMemo(() => tiposResumos.find((tipo) => tipo.value === params.resumoType), [tiposResumos, params]);
    const assistentes = useMemo(() => (tipoResumo?.parametrosJSON ? JSON.parse(tipoResumo.parametrosJSON) : []), [tipoResumo]);

    async function salvaResumoNoAtendimento(atendimento, params) {
        try {
            setLoadingResumo(true);
            setProcessandoAssistentes(true);

            const retorno = await salvaResumoAsync(atendimento.id, params.resumoType);
            closeResumoStreamDiv(retorno.texto);
            console.log('%c Log retorno gerado', retorno, 'color: green');
            toast.success('Resumo finalizado', { position: 'bottom-center' });
            setTimeout(() => {
                navigate(`/main/${params.id}/resumoViewer/${retorno.id}`);
            }, 1000);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 403) {
                toast.error(error.response.data.message);
                navigate(`/main`);
            } else {
                toast.error('Erro ao gerar resumo', { position: 'bottom-center' });
            }
        } finally {
            setLoadingResumo(false);
            setProcessandoAssistentes(false);
        }
    }

    // Efeito para animar os assistentes em loop
    useEffect(() => {
        if (!processandoAssistentes || assistentes.length === 0) return;

        const interval = setInterval(() => {
            setShowAssistente(false);

            setTimeout(() => {
                setAssistenteAtualIndex((prev) => (prev + 1) % assistentes.length);
                setShowAssistente(true);
            }, 500); // Tempo do fade out
        }, 3000); // Troca a cada 3 segundos

        return () => clearInterval(interval);
    }, [processandoAssistentes, assistentes.length]);

    useEffect(() => {
        if (atendimento?.id && params?.resumoType) {
            salvaResumoNoAtendimento(atendimento, params);
        }
    }, [atendimento, params]);

    async function closeResumoStreamDiv(textoMontado) {
        const objectResumo = {
            tipo: 'resumo',
            idAtendimento: atendimento.id,
            tipoResumo: tipoResumo?.value,
            texto: textoMontado,
            final: true,
        };
        window.parent.postMessage(objectResumo, '*');
    }

    useEffect(() => {
        console.log('Tipo de resumo selecionado:', tipoResumo);
    }, [tipoResumo]);
    useEffect(() => {
        console.log('Assistentes do resumo:', assistentes);
    }, [assistentes]);

    return (
        <Container>
            {/* <Typography
                variant="h6"
                component="h1"
                textTransform={'uppercase'}
                fontWeight={600}
                gutterBottom
                textAlign={'center'}
                fontSize={'1rem'}
            >
                {tipoResumo?.name}
            </Typography> */}

            {processandoAssistentes && (
                <>
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                            padding: 2,
                            backgroundColor: 'background.paper',
                            borderRadius: 2,
                            borderColor: 'divider',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'space-between',
                            height: '100%',
                        }}
                    >
                        <Box display={'flex'} flexDirection="column" alignItems="center" gap={2}>
                            <Typography variant="h6" color="primary.main" fontWeight={600} gutterBottom>
                                🤖 Gerando resumo: {tipoResumo?.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                Nossos assistentes especializados estão analisando seu atendimento.
                                <br />
                                Este processo pode levar alguns segundos.
                            </Typography>
                        </Box>

                        {assistentes.length > 0 && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '300px',
                                    width: '100%',
                                    flex: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        padding: 4,
                                        border: '2px solid',
                                        borderColor: 'primary.main',
                                        borderRadius: 3,
                                        backgroundColor: 'primary.light',
                                        textAlign: 'center',
                                        maxWidth: '500px',
                                        width: '100%',
                                        boxShadow: '0 8px 32px rgba(33, 150, 243, 0.3)',
                                        transform: 'scale(1.05)',
                                        transition: 'all 0.3s ease-in-out',
                                        gap: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Fade in={showAssistente} timeout={500}>
                                        <Box display={'flex'} flexDirection="column">
                                            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ color: '#fff' }}>
                                                Analisando "{assistentes[assistenteAtualIndex]?.titulo}"
                                            </Typography>

                                            <Typography variant="subtitle2" sx={{ marginBottom: 2, color: '#fff' }}>
                                                {assistentes[assistenteAtualIndex]?.descricao}
                                            </Typography>
                                        </Box>
                                    </Fade>

                                    <Typography
                                        variant="caption"
                                        color="primary.dark"
                                        fontWeight={600}
                                        sx={{
                                            display: 'inline-block',
                                            padding: '4px 12px',
                                            backgroundColor: 'primary.main',
                                            color: 'white',
                                            borderRadius: 1,
                                        }}
                                    >
                                        Processando...
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        <LinearProgress
                            sx={{
                                height: 6,
                                borderRadius: 3,
                                backgroundColor: 'grey.200',
                                '& .MuiLinearProgress-bar': {
                                    borderRadius: 3,
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                                },
                            }}
                        />
                    </Box>
                </>
            )}

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loadingResumo && !processandoAssistentes}
            >
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <CircularProgress color="inherit" />
                    <Typography variant="h6">Carregando...</Typography>
                </Box>
            </Backdrop>
        </Container>
    );
}

export default GerandoResumo;
